module.exports = __webpack_public_path__ + "media/Video 92.c2723da9.mp4";